import { Percent } from '@uniswap/sdk-core'
import chartIcon from 'assets/images/trade/chart-icon.svg'
import SettingsTab from 'components/Settings'
import { ForwardedRef, forwardRef, memo, ReactElement } from 'react'
import styled from 'styled-components/macro'

import { HideMedium } from '../../styles'

const StyledSwapHeader = styled.div`
  padding: 8px 12px;
  margin-bottom: 25px;
  width: 100%;
  color: ${({ theme }) => theme.textSecondary};

  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`
const SwapTitle = styled.span`
  font-size: 34px;
  font-family: 'Lexend Deca', sans-serif;
  font-weight: 400;
  color: ${({ theme }) => theme.swapHeaderForeground};
`
const Actions = styled.div`
  display: inline-flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
`
const ChartToggle = styled.span`
  width: 20px;
  height: 20px;
  display: inline-block;
  background: url(${chartIcon}) 50% / cover no-repeat;
  cursor: pointer;
`

interface IHeaderProps {
  allowedSlippage: Percent
  toggleChart: () => void
}

const Header = memo(
  forwardRef((props: IHeaderProps, ref: ForwardedRef<HTMLSpanElement>): ReactElement => {
    // eslint-disable-next-line react/prop-types
    const { allowedSlippage, toggleChart }: IHeaderProps = props
    return (
      <StyledSwapHeader>
        <SwapTitle>Trade</SwapTitle>
        <Actions>
          <HideMedium>
            <ChartToggle ref={ref} onClick={toggleChart} />
          </HideMedium>
          <SettingsTab placeholderSlippage={allowedSlippage} />
        </Actions>
      </StyledSwapHeader>
    )
  })
)

export default Header
